//20180830
document.write('<script src="/assets/js/mobile.js" type="text/javascript"><\/script>');

function alignParametricTable(){
	var heights = [];
	$('#parametricdata').find('tr:visible').each(function(i) {
		heights[i] = $(this).outerHeight();
	});

	//get visible table one rows before we remove it from the dom
	var tableOneRows = $('#paramsName').find('tr:visible');

	$.each(tableOneRows, function(i) {
		if (heights[i] > 33) {
			$(this).height(heights[i]);
		}
		else
			$(this).height(heights[i]-1);
	});
}

(function(c) {
    c.fn.__bind__ = c.fn.bind;
    c.fn.__unbind__ = c.fn.unbind;
    c.fn.__find__ = c.fn.find;
    var d = {
        version: "0.7.9",
        override: /keypress|keydown|keyup/g,
        triggersMap: {},
        specialKeys: {
            27: "esc",
            9: "tab",
            32: "space",
            13: "return",
            8: "backspace",
            145: "scroll",
            20: "capslock",
            144: "numlock",
            19: "pause",
            45: "insert",
            36: "home",
            46: "del",
            35: "end",
            33: "pageup",
            34: "pagedown",
            37: "left",
            38: "up",
            39: "right",
            40: "down",
            109: "-",
            112: "f1",
            113: "f2",
            114: "f3",
            115: "f4",
            116: "f5",
            117: "f6",
            118: "f7",
            119: "f8",
            120: "f9",
            121: "f10",
            122: "f11",
            123: "f12",
            191: "/"
        },
        shiftNums: {
            "`": "~",
            "1": "!",
            "2": "@",
            "3": "#",
            "4": "$",
            "5": "%",
            "6": "^",
            "7": "&",
            "8": "*",
            "9": "(",
            "0": ")",
            "-": "_",
            "=": "+",
            ";": ":",
            "'": '"',
            ",": "<",
            ".": ">",
            "/": "?",
            "\\": "|"
        },
        newTrigger: function(i, a, h) {
            var b = {};
            b[i] = {};
            b[i][a] = {
                cb: h,
                disableInInput: false
            };
            return b
        }
    };
    d.specialKeys = c.extend(d.specialKeys, {
        96: "0",
        97: "1",
        98: "2",
        99: "3",
        100: "4",
        101: "5",
        102: "6",
        103: "7",
        104: "8",
        105: "9",
        106: "*",
        107: "+",
        109: "-",
        110: ".",
        111: "/"
    });
    c.fn.find = function(a) {
        this.query = a;
        return c.fn.__find__.apply(this, arguments)
    };
    c.fn.unbind = function(i, a, k) {
        if (c.isFunction(a)) {
            k = a;
            a = null
        }
        if (a && typeof a === "string") {
            var b = ((this.prevObject && this.prevObject.query) || this[0].id || this[0]).toString();
            var l = i.split(" ");
            for (var m = 0; m < l.length; m++) {
                delete d.triggersMap[b][l[m]][a]
            }
        }
        return this.__unbind__(i, k)
    };
    c.fn.bind = function(s, w, a) {
    	if (s !== undefined && typeof s !== "string") {this.__bind__(s,w,a);return;}
        var x = s ? s.match(d.override) : "";
        if (c.isFunction(w) || !x) {
            return this.__bind__(s, w, a)
        } else {
            var p = null,
                u = c.trim(s.replace(d.override, ""));
            if (u) {
                p = this.__bind__(u, w, a)
            }
            if (typeof w === "string") {
                w = {
                    combi: w
                }
            }
            if (w.combi) {
                for (var r = 0; r < x.length; r++) {
                    var y = x[r];
                    var b = w.combi.toLowerCase(),
                        q = d.newTrigger(y, b, a),
                        v = ((this.prevObject && this.prevObject.query) || this[0].id || this[0]).toString();
                    q[y][b].disableInInput = w.disableInInput;
                    if (!d.triggersMap[v]) {
                        d.triggersMap[v] = q
                    } else {
                        if (!d.triggersMap[v][y]) {
                            d.triggersMap[v][y] = q[y]
                        }
                    }
                    var t = d.triggersMap[v][y][b];
                    if (!t) {
                        d.triggersMap[v][y][b] = [q[y][b]]
                    } else {
                        if (t.constructor !== Array) {
                            d.triggersMap[v][y][b] = [t]
                        } else {
                            d.triggersMap[v][y][b][t.length] = q[y][b]
                        }
                    }
                    this.each(function() {
                        var e = c(this);
                        if (e.attr("hkId") && e.attr("hkId") !== v) {
                            v = e.attr("hkId") + ";" + v
                        }
                        e.attr("hkId", v)
                    });
                    p = this.__bind__(x.join(" "), w, d.handler)
                }
            }
            return p
        }
    };
    d.findElement = function(a) {
        if (!c(a).attr("hkId")) {
            if (c.browser.opera || c.browser.safari) {
                while (!c(a).attr("hkId") && a.parentNode) {
                    a = a.parentNode
                }
            }
        }
        return a
    };
    d.handler = function(E) {
        var G = d.findElement(E.currentTarget),
            A = c(G),
            w = A.attr("hkId");
        if (w) {
            w = w.split(";");
            var y = E.which,
                a = E.type,
                B = d.specialKeys[y],
                C = !B && String.fromCharCode(y).toLowerCase(),
                F = E.shiftKey,
                u = E.ctrlKey,
                I = E.altKey || E.originalEvent.altKey,
                H = null;
            for (var J = 0; J < w.length; J++) {
                if (d.triggersMap[w[J]][a]) {
                    H = d.triggersMap[w[J]][a];
                    break
                }
            }
            if (H) {
                var b;
                if (!F && !u && !I) {
                    b = H[B] || (C && H[C])
                } else {
                    var x = "";
                    if (I) {
                        x += "alt+"
                    }
                    if (u) {
                        x += "ctrl+"
                    }
                    if (F) {
                        x += "shift+"
                    }
                    b = H[x + B];
                    if (!b) {
                        if (C) {
                            b = H[x + C] || H[x + d.shiftNums[C]] || (x === "shift+" && H[d.shiftNums[C]])
                        }
                    }
                }
                if (b) {
                    var D = false;
                    for (var J = 0; J < b.length; J++) {
                        if (b[J].disableInInput) {
                            var v = c(E.target);
                            if (A.is("input") || A.is("textarea") || A.is("select") || v.is("input") || v.is("textarea") || v.is("select")) {
                                return true
                            }
                        }
                        D = D || b[J].cb.apply(this, [E])
                    }
                    return D
                }
            }
        }
    };
    window.hotkeys = d;
    return c
})(jQuery);
$.ajaxSetup({
    cache: false
});
var diagramFlag = 0;
var showFlag = 0;
var symFootSortFlag = 0;
var symFootExecuteFlag = 0;
var paramNameFlag = 0;
var paramDataFlag = 0;
var paramExecuteFlag = 0;

function descInit() {
    $(".showMore").show();
    $(".showLess").hide();
    $(".showMore").children("a").click(function() {
        $(this).parent().parent().children(".cnt").removeClass("less");
        $(this).parent().parent().children(".showMore").hide();
        $(this).parent().parent().children(".showLess").show();
        $(this).parent().parent().children(".showMore").prev().slideDown();
        return false
    });
    $(".showLess").children("a").click(function() {
        $(this).parent().parent().children(".cnt").addClass("less");
        $(this).parent().parent().children(".showMore").show();
        $(this).parent().parent().children(".showLess").hide();
        return false
    })
}

function diagramInit() {
    var H = 1;
    var m = $("#maxLength").attr("value");
    if (m && diagramFlag == 0) {
        diagramFlag = 1;
        $("#diagramOverlay").hide();
        $("#modalWin").hide();
        $("#cntWin").hide();
        $("#overlayList").hide();
        $("#overlayClose").hide();
        var k = "";
        var u = "";
        var h = "";
        var l = "";
        var o = "";
        var f = 0;
        for (var v = 0; v < m; v++) {
            $("#imgTitle" + (v + 1)).hide();
            $("#image" + (v + 1)).hide();
            $("#list2" + (v + 1)).addClass("hide");
            if (v != 0) {
                $("#imageFullZoom" + (v + 1)).hide();
                $(".diagram .cnt #diaTitle" + (v + 1)).hide()
            } else {
                $(".diagram .list .li" + (v + 1)).addClass("on");
                $("#imageFullZoom" + (v + 1)).show();
                $(".diagram .cnt #diaTitle" + (v + 1)).show();
                $("#image" + (v + 1)).show();
                if ($("#zoomFullImg" + (v + 1)).attr("height") <= 100) {
                    $("#zoomFullImg" + (v + 1)).attr("height", 200)
                }
                if ($("#zoomFullImg" + (v + 1)).attr("width") <= 100) {
                    $("#zoomFullImg" + (v + 1)).attr("width", 200)
                }
                if ($("#zoomFullImg" + (v + 1)).attr("lang") > 400) {
                    var s = 250 * ($("#zoomImg" + (v + 1)).attr("height")) / ($("#zoomImg" + (v + 1)).attr("lang"));
                    $("#imageFullDrag" + (v + 1)).css("top", 250 - s);
                    var e = $("#imageFullDrag" + (v + 1)).position();
                    var H = ((250 - e.top) / 250) + 1;
                    H += ((25 - Math.ceil(e.top / 10))) * ($("#zoomFullImg" + (v + 1)).attr("lang") - $("#zoomImg" + (v + 1)).attr("height")) / 25000;
                    var d = "zoomFullImg" + (v + 1);
                    if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                        $("#" + d).css({
                            zoom: H,
                            "-o-transform": "scale(" + H + ")"
                        })
                    } else {
                        $("#" + d).css({
                            zoom: H,
                            "-moz-transform": "scale(" + H + ")"
                        })
                    }
                }
            }
            f = v + 1
        }
        if (m <= 1) {
            $(".forward").addClass("disabled");
            $(".backward").addClass("disabled");
        }
        var r = 1;
        var x = 1;
        var p = 1;
        for (j = 1; j <= x; j++) {
            $("#list2" + j).removeClass("hide");
        }
        $(".diagram .list2 .forward").click(function() {
            if (x >= r && (x < f)) {
                x = x + 1;
                for (v = 1; v <= p; v++) {
                    $("#list2" + v).addClass("hide");
                }
                p = p + 1;
                for (v = p; v <= x; v++) {
                    $("#list2" + v).removeClass("hide");
                }
                $(".diagramCount").text(x);
                if (x == m) {
                    $(".forward").addClass("disabled");
                }
                else {
                    $(".forward").removeClass("disabled");
                }
            }
            return false
        });
        $(".diagram .list2 .backward").click(function() {
            H = 1;
            var a = 0;
            if (p > 1 && p <= f) {
                for (v = p; v <= x; v++) {
                    $("#list2" + v).addClass("hide");
                }
                x = x - 1;
                p = p - 1;
                for (v = p; v <= x; v++) {
                    $("#list2" + v).removeClass("hide");
                }
                $(".diagramCount").text(x);

                if (x == 0) {
                    $(".backward").addClass("disabled");
                }
                else {
                    $(".backward").removeClass("disabled");
                }
            }
            return false
        });
        $(".diagram .list2 .items a.nondownload").click(function() {
            a = 1;
            l = $(this).attr("id");
            var i = "zoomImg" + l;
            var w = "zoomFullImg" + l;
            if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                $("#" + i).css({
                    zoom: a,
                    "-o-transform": "scale(" + a + ")"
                });
                $("#" + w).css({
                    zoom: a,
                    "-o-transform": "scale(" + a + ")"
                })
            } else {
                $("#" + i).css({
                    zoom: a,
                    "-moz-transform": "scale(" + a + ")"
                });
                $("#" + w).css({
                    zoom: a,
                    "-moz-transform": "scale(" + a + ")"
                })
            }
            var c = $("#diagram");
            var b = c.offset();
            $("#modalWin").css("top", (b.top - 50));
            $("#modalWin").show();
            $("#diagramOverlay").show();
            $("#cntWin").show();
            $("#overlayList").show();
            window.location.href = "#modalWin";
            $("#overlayClose").show();
            h = ".modal .list .liWin" + $(this).attr("id");
            k = "#imageWin" + $(this).attr("id");
            u = "#imgTitleWin" + $(this).attr("id");
            com.TI.Product.displayZoomedImg(k, u, h, l, o);
            o = l;
            for (var q = 0; q < m; q++) {
                if ((q + 1) != $(this).attr("id")) {
                    $(".liWin" + (q + 1)).removeClass("on");
                    $("#imageWin" + (q + 1)).hide();
                    $("#imgTitleWin" + (q + 1)).hide();
                    $("#imageZoom" + (q + 1)).hide();
                    $("#zoomImg" + (q + 1)).hide();
                    $("#zoomFullImg" + (q + 1)).hide();
                    $(".diagram .cnt #diaTitle" + (q + 1)).hide()
                } else {
                    $(".liWin" + (q + 1)).addClass("on");
                    $("#imageWin" + (q + 1)).show();
                    $("#imgTitleWin" + (q + 1)).show();
                    $("#imageZoom" + (q + 1)).show();
                    $("#zoomImg" + (q + 1)).show();
                    $("#zoomFullImg" + (q + 1)).show();
                    $(".diagram .cnt #diaTitle" + (q + 1)).show();
                    if ($("#zoomImg" + (q + 1)).attr("height") <= 100) {
                        $("#zoomImg" + (q + 1)).attr("height", 200)
                    }
                    if ($("#zoomImg" + (q + 1)).attr("width") <= 100) {
                        $("#zoomImg" + (q + 1)).attr("width", 200)
                    }
                    if ($("#zoomImg" + (q + 1)).attr("lang") > 400) {
                        var t = 250 * ($("#zoomImg" + (q + 1)).attr("height")) / ($("#zoomImg" + (q + 1)).attr("lang"));
                        $("#imageDrag" + (q + 1)).css("top", 250 - t);
                        var n = $("#imageDrag" + (q + 1)).position();
                        var a = ((250 - n.top) / 250) + 1;
                        a += ((25 - Math.ceil(n.top / 10))) * ($("#zoomImg" + (q + 1)).attr("lang") - $("#zoomImg" + (q + 1)).attr("height")) / 25000;
                        var i = "zoomImg" + (q + 1);
                        if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                            $("#" + i).css({
                                zoom: a,
                                "-o-transform": "scale(" + a + ")"
                            })
                        } else {
                            $("#" + i).css({
                                zoom: a,
                                "-moz-transform": "scale(" + a + ")"
                            })
                        }
                    }
                }
            }
            return false
        });
        k = "#image1";
        u = "#imgTitle1";
        h = "#li1";
        l = "1";
        com.TI.Product.displayZoomedImg(k, u, h, l, o);
        $(".diagram .list a").click(function() {
            t = 1;
            l = $(this).attr("id");
            var w = "zoomImg" + l;
            var i = "zoomFullImg" + l;
            if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                $("#" + w).css({
                    zoom: t,
                    "-o-transform": "scale(" + t + ")"
                });
                $("#" + i).css({
                    zoom: t,
                    "-o-transform": "scale(" + t + ")"
                })
            } else {
                $("#" + w).css({
                    zoom: t,
                    "-moz-transform": "scale(" + t + ")"
                });
                $("#" + i).css({
                    zoom: t,
                    "-moz-transform": "scale(" + t + ")"
                })
            }
            k = ".diagram .cnt .image" + $(this).attr("id");
            u = ".diagram .cnt .imgTitle" + $(this).attr("id");
            h = ".diagram .list .li" + $(this).attr("id");
            l = $(this).attr("id");
            com.TI.Product.displayZoomedImg(k, u, h, l, o);
            o = l;
            for (var c = 0; c < m; c++) {
                if ((c + 1) != $(this).attr("id")) {
                    $(".diagram .list .li" + (c + 1)).removeClass("on");
                    $(".liWin" + (c + 1)).removeClass("on");
                    $(".diagram .cnt #zoomFullImg" + (c + 1)).hide();
                    $(".diagram .cnt #diaTitle" + (c + 1)).hide();
                    $("#imageFullZoom" + (c + 1)).hide();
                    $("#imageZoom" + (c + 1)).hide();
                    $("#zoomImg" + (c + 1)).hide();
                    $("#imageWin" + (c + 1)).hide();
                    $("#zoomFullImg" + (c + 1)).hide();
                    $("#image" + (c + 1)).hide()
                } else {
                    $(".diagram .list .li" + (c + 1)).addClass("on");
                    $(".liWin" + (c + 1)).addClass("on");
                    $(".diagram .cnt .image" + (c + 1)).show();
                    $(".diagram .cnt #diaTitle" + (c + 1)).show();
                    $("#imageFullZoom" + (c + 1)).show();
                    $("#imageZoom" + (c + 1)).show();
                    $("#zoomImg" + (c + 1)).show();
                    $("#imageWin" + (c + 1)).show();
                    $("#zoomFullImg" + (c + 1)).show();
                    $("#image" + (c + 1)).show();
                    if ($("#zoomImg" + (c + 1)).attr("height") <= 100) {
                        $("#zoomImg" + (c + 1)).attr("height", 200)
                    }
                    if ($("#zoomImg" + (c + 1)).attr("width") <= 100) {
                        $("#zoomImg" + (c + 1)).attr("width", 200)
                    }
                    if ($("#zoomFullImg" + (c + 1)).attr("height") <= 100) {
                        $("#zoomFullImg" + (c + 1)).attr("height", 200)
                    }
                    if ($("#zoomFullImg" + (c + 1)).attr("width") <= 100) {
                        $("#zoomFullImg" + (c + 1)).attr("width", 200)
                    }
                    if ($("#zoomImg" + (c + 1)).attr("lang") > 400) {
                        var q = 250 * ($("#zoomImg" + (c + 1)).attr("height")) / ($("#zoomImg" + (c + 1)).attr("lang"));
                        $("#imageDrag" + (c + 1)).css("top", 250 - q);
                        var n = $("#imageDrag" + (c + 1)).position();
                        var t = ((250 - n.top) / 250) + 1;
                        t += ((25 - Math.ceil(n.top / 10))) * ($("#zoomImg" + (c + 1)).attr("lang") - $("#zoomImg" + (c + 1)).attr("height")) / 25000;
                        var w = "zoomImg" + (c + 1);
                        if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                            $("#" + w).css({
                                zoom: t,
                                "-o-transform": "scale(" + t + ")"
                            })
                        } else {
                            $("#" + w).css({
                                zoom: t,
                                "-moz-transform": "scale(" + t + ")"
                            })
                        }
                        var a = 250 * ($("#zoomFullImg" + (c + 1)).attr("height")) / ($("#zoomFullImg" + (c + 1)).attr("lang"));
                        $("#imageFullDrag" + (c + 1)).css("top", 250 - a);
                        var n = $("#imageFullDrag" + (c + 1)).position();
                        var b = ((250 - n.top) / 250) + 1;
                        b += ((25 - Math.ceil(n.top / 10))) * ($("#zoomFullImg" + (c + 1)).attr("lang") - $("#zoomFullImg" + (c + 1)).attr("height")) / 25000;
                        var i = "zoomFullImg" + (c + 1);
                        if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                            $("#" + i).css({
                                zoom: b,
                                "-o-transform": "scale(" + b + ")"
                            })
                        } else {
                            $("#" + i).css({
                                zoom: b,
                                "-moz-transform": "scale(" + b + ")"
                            })
                        }
                    }
                }
            }
            return false
        });
        $("#overlayClose").click(function() {
            $("#modalWin").hide();
            $("#diagramOverlay").hide();
            $("#overlayClose").hide();
            return false
        });
        $("#cntWin .zoomout").click(function() {
            var n = $(this).attr("id");
            var a = $("#imageZoomOut" + n.charAt(n.length - 1)).position();
            var i = $("#imageDrag" + n.charAt(n.length - 1)).position();
            H = ((250 - i.top) / 250) + 1;
            H += ((25 - Math.ceil(i.top / 10)) * ($("#zoomImg" + n.charAt(n.length - 1)).attr("lang") - $("#zoomImg" + n.charAt(n.length - 1)).attr("height"))) / 25000;
            H -= $("#zoomImg" + n.charAt(n.length - 1)).attr("lang") / 25000;
            var c = "zoomImg" + n.charAt(n.length - 1);
            var b = $("#imageDrag" + n.charAt(n.length - 1)).position();
            if (H > 0 && i.top < (a.top - 20)) {
                $("#imageDrag" + n.charAt(n.length - 1)).css("top", (b.top + 10));
                if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                    $("#" + c).css({
                        zoom: H,
                        "-o-transform": "scale(" + H + ")"
                    })
                } else {
                    $("#" + c).css({
                        zoom: H,
                        "-moz-transform": "scale(" + H + ")"
                    })
                }
            }
        });
        $("#cnt .zoomout").click(function() {
            var n = $(this).attr("id");
            var a = $("#imageFullZoomOut" + n.charAt(n.length - 1)).position();
            var i = $("#imageFullDrag" + n.charAt(n.length - 1)).position();
            H = ((250 - i.top) / 250) + 1;
            H += ((25 - Math.ceil(i.top / 10)) * ($("#zoomFullImg" + n.charAt(n.length - 1)).attr("lang") - $("#zoomFullImg" + n.charAt(n.length - 1)).attr("height"))) / 25000;
            H -= $("#zoomFullImg" + n.charAt(n.length - 1)).attr("lang") / 25000;
            var c = "zoomFullImg" + n.charAt(n.length - 1);
            var b = $("#imageFullDrag" + n.charAt(n.length - 1)).position();
            if (H > 0 && i.top < (a.top - 20)) {
                $("#imageFullDrag" + n.charAt(n.length - 1)).css("top", (b.top + 10));
                if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                    $("#" + c).css({
                        zoom: H,
                        "-o-transform": "scale(" + H + ")"
                    })
                } else {
                    $("#" + c).css({
                        zoom: H,
                        "-moz-transform": "scale(" + H + ")"
                    })
                }
            }
        });
        $("#cntWin .zoomin").click(function() {
            var a = $(this).attr("id");
            var n = $("#imageZoomIn" + a.charAt(a.length - 1)).position();
            var i = $("#imageDrag" + a.charAt(a.length - 1)).position();
            H = ((250 - i.top) / 250) + 1;
            H += $("#zoomImg" + a.charAt(a.length - 1)).attr("lang") / (Math.ceil(i.top / 10) * 100);
            var c = "zoomImg" + a.charAt(a.length - 1);
            var b = $("#imageDrag" + a.charAt(a.length - 1)).position();
            if (H > 0 && i.top > (n.top + 20)) {
                $("#imageDrag" + a.charAt(a.length - 1)).css("top", (b.top - 10));
                if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                    $("#" + c).css({
                        zoom: H,
                        "-o-transform": "scale(" + H + ")"
                    })
                } else {
                    $("#" + c).css({
                        zoom: H,
                        "-moz-transform": "scale(" + H + ")"
                    })
                }
            }
        });
        $("#cnt .zoomin").click(function() {
            var a = $(this).attr("id");
            var n = $("#imageFullZoomIn" + a.charAt(a.length - 1)).position();
            var i = $("#imageFullDrag" + a.charAt(a.length - 1)).position();
            H = ((250 - i.top) / 250) + 1;
            H += $("#zoomFullImg" + a.charAt(a.length - 1)).attr("lang") / (Math.ceil(i.top / 10) * 100);
            var c = "zoomFullImg" + a.charAt(a.length - 1);
            var b = $("#imageFullDrag" + a.charAt(a.length - 1)).position();
            if (H > 0 && i.top > (n.top + 20)) {
                $("#imageFullDrag" + a.charAt(a.length - 1)).css("top", (b.top - 10));
                if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                    $("#" + c).css({
                        zoom: H,
                        "-o-transform": "scale(" + H + ")"
                    })
                } else {
                    $("#" + c).css({
                        zoom: H,
                        "-moz-transform": "scale(" + H + ")"
                    })
                }
            }
        });
        $("#cntWin .drag").draggable({
            axis: "y",
            containment: "parent",
            start: function(b, a) {
                ypos = b.clientY
            },
            drag: function(c, w) {
                var i = $(this).attr("id");
                var t = $("#imageZoomIn" + i.charAt(i.length - 1)).position();
                var q = $("#imageZoomOut" + i.charAt(i.length - 1)).position();
                var n = $("#imageDrag" + i.charAt(i.length - 1)).position();
                H = ((250 - n.top) / 250) + 1;
                var b = ypos - c.clientY;
                if (b > 0) {
                    H += $("#zoomImg" + i.charAt(i.length - 1)).attr("lang") / (Math.ceil(n.top / 10) * 100)
                }
                if (b < 0) {
                    H += ((25 - Math.ceil(n.top / 10)) * ($("#zoomImg" + i.charAt(i.length - 1)).attr("lang") - $("#zoomImg" + i.charAt(i.length - 1)).attr("height"))) / 25000;
                    H -= ($("#zoomImg" + i.charAt(i.length - 1)).attr("lang")) / (25000 * 4)
                }
                if (H > 0 && n.top > (t.top + 20) && n.top < (q.top - 20)) {
                    var a = "zoomImg" + i.charAt(i.length - 1);
                    if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                        $("#" + a).css({
                            zoom: H,
                            "-o-transform": "scale(" + H + ")"
                        })
                    } else {
                        $("#" + a).css({
                            zoom: H,
                            "-moz-transform": "scale(" + H + ")"
                        })
                    }
                }
                ypos = c.clientY
            }
        });
        $("#cnt .drag").draggable({
            axis: "y",
            containment: "parent",
            start: function(b, a) {
                ypos = b.pageY
            },
            drag: function(c, w) {
                var i = $(this).attr("id");
                var t = $("#imageFullZoomIn" + i.charAt(i.length - 1)).position();
                var q = $("#imageFullZoomOut" + i.charAt(i.length - 1)).position();
                var n = $("#imageFullDrag" + i.charAt(i.length - 1)).position();
                H = ((250 - n.top) / 250) + 1;
                var b = ypos - c.clientY;
                if (b > 0) {
                    H += $("#zoomFullImg" + i.charAt(i.length - 1)).attr("lang") / (Math.ceil(n.top / 10) * 400)
                }
                if (b < 0) {
                    H += ((25 - Math.ceil(n.top / 10)) * ($("#zoomFullImg" + i.charAt(i.length - 1)).attr("lang") - $("#zoomFullImg" + i.charAt(i.length - 1)).attr("height"))) / 25000;
                    H -= $("#zoomFullImg" + i.charAt(i.length - 1)).attr("lang") / (Math.ceil(n.top / 10) * 400)
                }
                H += $("#zoomFullImg" + i.charAt(i.length - 1)).attr("lang") / (Math.ceil(n.top / 10) * 400);
                if (H > 0 && n.top > (t.top + 20) && n.top < (q.top - 20)) {
                    var a = "zoomFullImg" + i.charAt(i.length - 1);
                    if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                        $("#" + a).css({
                            zoom: H,
                            "-o-transform": "scale(" + H + ")"
                        })
                    } else {
                        $("#" + a).css({
                            zoom: H,
                            "-moz-transform": "scale(" + H + ")"
                        })
                    }
                }
                ypos = c.clientY
            }
        });
        $(".diagram .image").draggable({})
    }
}

function symFootSorting() {
    symFootSortFlag = $("#tblSymbol tr").length;
    if (symFootSortFlag > 0 && symFootExecuteFlag == 0) {
        symFootExecuteFlag = 1;
        if ($("#tblSymbol tr").length > 2) {
            var c = {};
            var f = 0;
            $.tablesorter.addParser({
                id: "anchor",
                is: function(a) {
                    return false
                },
                format: function(a) {
                    return $(a).text()
                },
                type: "text"
            });
            $("#tblSymbol th").each(function(a) {
                if ($(this).attr("id") != "2") {
                    c[a] = {
                        sorter: false
                    }
                } else {
                    if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
                        c[a] = {
                            sorter: "anchor"
                        }
                    } else {
                        c[a] = {
                            sorter: "text"
                        }
                    }
                }
            });
            $("#tblSymbol").tablesorter({
                sortList: [
                    [1, 0]
                ],
                headers: c
            });
            $("#tblSymbol th").each(function(a) {
                if ($(this).attr("id") != "2") {
                    $(this).removeClass("header")
                }
            });
            var b = $("#tblSymbol tr").length - 1;
            $("#tblSymbol").bind("sortEnd", function() {
                $("#tblSymbol tr").each(function(a) {
                    if (a > 1) {
                        $("#tblSymbol tr:eq(" + a + ") td:eq(0)").text("")
                    }
                });
                $("#tblSymbol tr:eq(1) td:eq(0)").text(window.genericPartNumber);
                $("#tblSymbol tr:eq(1) td:eq(0)").css("border-bottom", "0px");
                $("#tblSymbol tr").each(function(a) {
                    if (a > 1) {
                        $("#tblSymbol tr:eq(" + a + ") td:eq(0)").text("");
                        $("#tblSymbol tr:eq(" + a + ") td:eq(0)").css("border-top", "0px");
                        $("#tblSymbol tr:eq(" + a + ") td:eq(0)").css("border-bottom", "0px")
                    }
                    if (a == b) {
                        $("#tblSymbol tr:eq(" + a + ") td:eq(0)").css("border-bottom", "1px solid");
                        $("#tblSymbol tr:eq(" + a + ") td:eq(0)").css("border-color", "#C0C0C0")
                    }
                })
            })
        }
        symFootSortFlag = 0
    }
}

function readDistCookie(b) {
    var e = b + "=";
    var a = document.cookie.split(";");
    for (var d = 0; d < a.length; d++) {
        var f = a[d];
        while (f.charAt(0) == " ") {
            f = f.substring(1, f.length)
        }
        if (f.indexOf(e) == 0) {
            return f.substring(e.length, f.length)
        }
    }
    return null
}
$(document).ready(function() {
    var L = window.location.href;
    if (L != null && L != "" && typeof L !== "undefined") {
        if (L.lastIndexOf("/product/") > -1) {
            var b;
            if (L.lastIndexOf("/product/cn/") > -1) {
                b = L.lastIndexOf("/product/cn/") + 12
            } else {
                if (L.lastIndexOf("/product/jp/") > -1) {
                    b = L.lastIndexOf("/product/jp/") + 12
                } else {
                    if (L.lastIndexOf("/product/") > -1) {
                        b = L.lastIndexOf("/product/") + 9
                    }
                }
            }
            var n = L.substring(0, b);
            var v = L.substring(b);
            if (v.indexOf("/") === -1) {
                if (v.indexOf("#") > -1) {
                    if (v.indexOf("?") > -1) {
                        var c = v.split("?");
                        var x = c[1];
                        var C = x.split("#");
                        var u = C.pop();
                        var s;
                        if (u == "desKit") {
                            s = n + c[0] + "/toolssoftware?" + C;
                            window.location.href = s
                        }
                        if (u == "TIDesigns" || u == "softTools" || u == "devtools" || u == "simulationmodels" || u == "3rdProds") {
                            s = n + c[0] + "/toolssoftware?" + C;
                            window.location.href = s
                        }
                    } else {
                        var S;
                        var E = v.split("#");
                        if (E[0] != null) {
                            S = E[0]
                        }
                        var a = E[1];
                        if (a == "toolssoftware") {
                            S = n + S + "/toolssoftware";
                            window.location.href = S
                        } else if (a == "desKit") {
                            S = n + S + "/toolssoftware";
                            window.location.href = S
                        } else if (a == "TIDesigns" || a == "softTools" || a == "devtools" || a == "simulationmodels" || a == "3rdProds") {
                            S = n + S + "/toolssoftware";
                            window.location.href = S
                        }
                    }
                }
            }
        }
    }
    $(document).bind("keydown", "Ctrl+f", function() {
        if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            $(".showMore").children("a").each(function() {
                $(this).parent().parent().children(".cnt").removeClass("less");
                $(this).parent().parent().children(".showMore").hide();
                $(this).parent().parent().children(".showLess").show();
                $(this).parent().parent().children(".showMore").prev().slideDown()
            })
        }
    });
    $(".showMore .showButton").click(function(i) {
        var h = $(this),
            d = h.find("span");
        h.parent().toggleClass("showLess");
        var f = d.text().toLowerCase();
        if (f == "詳細を表示") {
            d.text("詳細を非表示")
        } else {
            d.text("詳細を表示")
        }
    });
    if ($.tablesorter) {
        $.tablesorter.addParser({
            id: "NotEmptyFirst",
            is: function(d) {
                return false
            },
            format: function(d) {
                return (d.match(/[^\s]/)) ? 0 : 1
            },
            type: "text"
        });
        $.tablesorter.addParser({
            id: "commaDigit",
            is: function(e, d) {
                var f = d.config;
                return $.tablesorter.isDigit(e.replace(/[,.]/g, ""), f)
            },
            format: function(d) {
                return $.tablesorter.formatFloat(d.replace(/[,.]/g, ""))
            },
            type: "numeric"
        });
        $.tablesorter.addParser({
            id: "AlphaNum",
            is: function(d) {
                return false
            },
            format: function(d) {
                d = "" + d;
                d = d.toUpperCase();
                d = d.replace(/<.*?>/g, "");
                if (isNaN(d)) {
                    return "ZZ" + d
                } else {
                    //padstring throwing sonar exception, might be defined in a jsp so not deleting this one as it seems generic enough
                    return "AA" + PadString(d, "00000000"); // NOSONAR
                }
            },
            type: "text"
        });
        $.tablesorter.addParser({
            id: "dd mmm yyyy",
            is: function(d) {
                return false
            },
            format: function(d) {
                return +new Date(d)
            },
            type: "numeric"
        });
        var Q = {};
        Q.JAN = "01";
        Q.FEB = "02";
        Q.MAR = "03";
        Q.APR = "04";
        Q.MAY = "05";
        Q.JUN = "06";
        Q.JUL = "07";
        Q.AUG = "08";
        Q.SEP = "09";
        Q.OCT = "10";
        Q.NOV = "11";
        Q.DEC = "12";
        $.tablesorter.addParser({
            id: "DD MMM YYYY",
            is: function(d) {
                return false
            },
            format: function(e) {
                e = "" + e;
                var d = e.match(/(\d{2}) ([A-Za-z]{3}) (\d{4})/);
                if (d && d.length == 4) {
                    return d[3] + Q[d[2].toUpperCase()] + d[1]
                } else {
                    return e
                }
            },
            type: "text"
        });
    }
    if ($("#tblBuy tr").length > 2) {
        $("#tblBuy").tablesorter({
            sortList: [
                 [0, 0]
            ]
        })
    }
    if ($("#tblQuality tr").length > 2) {
        $("#tblQuality").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
 if ($("#tblRelProd tr").length > 2) {
         $("#tblRelProd").tablesorter({})
     }

    if ($("#tblSoftTool tr").length > 2) {
        $("#tblSoftTool").tablesorter({
            sortList: [
                [2, 0]
            ]
        })
    }
    if ($("#tblModel tr").length > 2) {
        $("#tblModel").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    if ($("#tblRefDes tr").length > 2) {
        $("#tblRefDes").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    if ($("#tblDesKit tr").length > 2) {
        $("#tblDesKit").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    if ($("#tblDevTool tr").length > 2) {
        $("#tblDevTool").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    if ($("#tbl3rdProd tr").length > 2) {
        $("#tbl3rdProd").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    if ($("#tblAppNote tr").length > 2) {
        if ($("#tblAppNote").find("tr")[0].cells.length == 7) {
            $("#tblAppNote").tablesorter({
                sortList: [
                    [($("#tblAppNote").find("tr")[0].cells.length - 3), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    },
                    5: {
                        sorter: "commaDigit"
                    }
                }
            })
        }
        if ($("#tblAppNote").find("tr")[0].cells.length == 6) {
            $("#tblAppNote").tablesorter({
                sortList: [
                    [($("#tblAppNote").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    2: {
                        sorter: "commaDigit"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    }
		                    }
            })
        }
        if ($("#tblAppNote").find("tr")[0].cells.length == 2) {
            $("#tblAppNote").tablesorter({
                sortList: [
                    [($("#tblAppNote").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
    }
    if ($("#tblDatasheet tr").length > 2) {
        if ($("#tblDatasheet").find("tr")[0].cells.length == 7) {
            $("#tblDatasheet").tablesorter({
                sortList: [
                    [($("#tblDatasheet").find("tr")[0].cells.length - 3), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    },
                    5: {
                        sorter: "commaDigit"
                    }
                }
            })
        }
        if ($("#tblDatasheet").find("tr")[0].cells.length == 6) {
            $("#tblDatasheet").tablesorter({
                sortList: [
                    [($("#tblDatasheet").find("tr")[0].cells.length - 3), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    2: {
                        sorter: "commaDigit"
                    },
                    3: {
                        sorter: "YYYY MMM DD"
                    },
                    4: {
                        sorter: "commaDigit"
                    }
                }
            })
        }
        if ($("#tblDatasheet").find("tr")[0].cells.length == 2) {
            $("#tblDatasheet").tablesorter({
                sortList: [
                    [($("#tblDatasheet").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
    }
    if ($("#tblUserGui tr").length > 2) {
        if ($("#tblUserGui").find("tr")[0].cells.length == 7) {
            $("#tblUserGui").tablesorter({
                sortList: [
                    [($("#tblUserGui").find("tr")[0].cells.length - 3), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    },
                    5: {
                        sorter: "commaDigit"
                    }
                }
            })
        }
        if ($("#tblUserGui").find("tr")[0].cells.length == 6) {
            $("#tblUserGui").tablesorter({
                sortList: [
                    [($("#tblUserGui").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    2: {
                        sorter: "commaDigit"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
        if ($("#tblUserGui").find("tr")[0].cells.length == 2) {
            $("#tblUserGui").tablesorter({
                sortList: [
                    [($("#tblUserGui").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
    }
    if ($("#tbl3rdDoc tr").length > 2) {
        $("#tbl3rdDoc").tablesorter({
            sortList: [
                [1, 1]
            ],
            headers: {
                0: {
                    sorter: "AlphaNum"
                },
                1: {
                    sorter: "YYYY MMM DD"
                }
            }
        })
    }
    if ($("#tblErrata tr").length > 2) {
        if ($("#tblErrata").find("tr")[0].cells.length == 7) {
            $("#tblErrata").tablesorter({
                sortList: [
                    [($("#tblErrata").find("tr")[0].cells.length - 3), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    },
                    5: {
                        sorter: "commaDigit"
                    }
                }
            })
        }
        if ($("#tblErrata").find("tr")[0].cells.length == 6) {
            $("#tblErrata").tablesorter({
                sortList: [
                    [($("#tblErrata").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    2: {
                        sorter: "commaDigit"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
        if ($("#tblErrata").find("tr")[0].cells.length == 2) {
            $("#tblErrata").tablesorter({
                sortList: [
                    [($("#tblErrata").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
    }
    if ($("#tblWhiPap tr").length > 2) {
        if ($("#tblWhiPap").find("tr")[0].cells.length == 7) {
            $("#tblWhiPap").tablesorter({
                sortList: [
                    [($("#tblWhiPap").find("tr")[0].cells.length - 3), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    },
                    5: {
                        sorter: "commaDigit"
                    }
                }
            })
        }
        if ($("#tblWhiPap").find("tr")[0].cells.length == 6) {
            $("#tblWhiPap").tablesorter({
                sortList: [
                    [($("#tblWhiPap").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    2: {
                        sorter: "commaDigit"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
        if ($("#tblWhiPap").find("tr")[0].cells.length == 2) {
            $("#tblWhiPap").tablesorter({
                sortList: [
                    [($("#tblWhiPap").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
    }
    if ($("#tblExtArt tr").length > 2) {
        $("#tblExtArt").tablesorter({
            sortList: [
                [1, 1]
            ],
            headers: {
                0: {
                    sorter: "AlphaNum"
                },
                1: {
                    sorter: "YYYY MMM DD"
                }
            }
        })
    }
    if ($("#tblSelGui tr").length > 2) {
        if ($("#tblSelGui").find("tr")[0].cells.length == 7) {
            $("#tblSelGui").tablesorter({
                sortList: [
                    [($("#tblSelGui").find("tr")[0].cells.length - 3), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    },
                    5: {
                        sorter: "commaDigit"
                    }
                }
            })
        }
        if ($("#tblSelGui").find("tr")[0].cells.length == 6) {
            $("#tblSelGui").tablesorter({
                sortList: [
                    [($("#tblSelGui").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "NotEmptyFirst"
                    },
                    2: {
                        sorter: "commaDigit"
                    },
                    3: {
                        sorter: "commaDigit"
                    },
                    4: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
        if ($("#tblSelGui").find("tr")[0].cells.length == 2) {
            $("#tblSelGui").tablesorter({
                sortList: [
                    [($("#tblSelGui").find("tr")[0].cells.length - 2), 1]
                ],
                headers: {
                    0: {
                        sorter: "AlphaNum"
                    },
                    1: {
                        sorter: "YYYY MMM DD"
                    }
                }
            })
        }
    }
    $("#tblBuy").find("input[type=button]").each(function() {
        var d = $(this).attr("id");
        if (d.indexOf("_sample") > 0) {
            $(this).removeClass("btndisabled");
            $(this).addClass("button btnA");
            $(this).removeAttr("disabled")
        }
    });
    $("#tblBuy").find("input[type=submit]").each(function() {
        $(this).removeClass("btndisabled");
        $(this).addClass("button btnA");
        $(this).removeAttr("disabled")
    });
    $(".parametric").show();
    $("#parametrictab").click(function() {
        $(".parametric").show();
        $(".compare").hide();
        $("#parametrictab").closest("li").addClass("on");
        $("#comparetab").closest("li").removeClass("on");
        return false
    });
    $("#comparetab").click(function() {
        if ($(".compare").hasClass("firstload")) {
            $(".compare").css({
                height: "",
                width: "",
                overflow: ""
            }).removeClass("firstload")
        }
        $(".parametric").hide();
        $(".compare").show();
        $("#comparetab").closest("li").addClass("on");
        $("#parametrictab").closest("li").removeClass("on");
        return false
    });
    $("#subcompare").click(function() {
        if ($(".compare").hasClass("firstload")) {
            $(".compare").css({
                height: "",
                width: "",
                overflow: ""
            }).removeClass("firstload")
        }
        $(".parametric").hide();
        $(".compare").show();
        $("#comparetab").closest("li").addClass("on");
        $("#parametrictab").closest("li").removeClass("on");
        window.location.href = "#seltool";
        return false
    });
    $("#crosssellcart").hide();
    $("#over").hide();
    $(".overlay").hide();
    $("#contactoverlay").hide();
    $("#modalcontact").hide();
    $("#contactform").hide();
    $("#contactclose").hide();
    $("#contactclose").click(function() {
        $("#mainanchor").show();
        $("#contactoverlay").hide();
        $("#modalcontact").hide();
        $("#contactform").hide()
    });
    var D = null;

    function P() {
        $(".anchor.sub.description").hide();
        $("span.description").removeClass("on");
        return false
    }

    function F() {
        $(".anchor.sub.buy").hide();
        $("span.buy").removeClass("on");
        return false
    }

    function G() {
        $(".anchor.sub.techdoc").hide();
        $("span.techdoc").removeClass("on");
        return false
    }

    function M() {
        $(".anchor.sub.tool").hide();
        $("span.tool").removeClass("on");
        return false
    }

    function t() {
        $(".anchor.sub.support").hide();
        $("span.support").removeClass("on");
        return false
    }
    $(".anchor.sub").hide();
    $(".anchor .description").mouseover(function() {
        if (D != null) {
            clearTimeout(D)
        }
        $(".anchor.sub.description").show();
        $("span.description").addClass("on");
        return false
    });
    $(".anchor .description").mouseout(function() {
        $(".anchor.sub.description").mouseover(function(d) {
            eventType = d.type;
            if (D != null) {
                clearTimeout(D)
            }
            $(".anchor.sub.description").show();
            $("span.description").addClass("on");
            return false
        });
        $(".anchor.sub.description").mouseleave(function(d) {
            eventType = d.type;
            if (D != null) {
                D = null
            }
            if (D == null) {
                D = "Set";
                setTimeout(P, 250)
            }
        })
    });
    $(".anchor .description").mouseleave(function() {
        P()
    });
    $(".anchor .buy").mouseover(function() {
        if (D != null) {
            clearTimeout(D)
        }
        $(".anchor.sub.buy").show();
        $("span.buy").addClass("on");
        return false
    });
    $(".anchor .buy").mouseout(function() {
        $(".anchor.sub.buy").mouseover(function() {
            if (D != null) {
                clearTimeout(D)
            }
            $(".anchor.sub.buy").show();
            $("span.buy").addClass("on");
            return false
        });
        $(".anchor.sub.buy").mouseleave(function() {
            if (D != null) {
                D = null
            }
            if (D == null) {
                D = "Set";
                setTimeout(F, 250)
            }
        })
    });
    $(".anchor .buy").mouseleave(function() {
        F()
    });
    $(".anchor .techdoc").mouseover(function() {
        if (D != null) {
            clearTimeout(D)
        }
        $(".anchor.sub.techdoc").show();
        $("span.techdoc").addClass("on");
        return false
    });
    $(".anchor .techdoc").mouseout(function() {
        $(".anchor.sub.techdoc").mouseover(function() {
            if (D != null) {
                clearTimeout(D)
            }
            $(".anchor.sub.techdoc").show();
            $("span.techdoc").addClass("on");
            return false
        });
        $(".anchor.sub.techdoc").mouseleave(function() {
            if (D != null) {
                D = null
            }
            if (D == null) {
                D = "Set";
                setTimeout(G, 250)
            }
        })
    });
    $(".anchor .techdoc").mouseleave(function() {
        G()
    });
    $(".anchor .tool").mouseover(function() {
        if (D != null) {
            clearTimeout(D)
        }
        $(".anchor.sub.tool").show();
        $("span.tool").addClass("on");
        return false
    });
    $(".anchor .tool").mouseout(function() {
        $(".anchor.sub.tool").mouseover(function() {
            if (D != null) {
                clearTimeout(D)
            }
            $(".anchor.sub.tool").show();
            $("span.tool").addClass("on");
            return false
        });
        $(".anchor.sub.tool").mouseleave(function() {
            if (D != null) {
                D = null
            }
            if (D == null) {
                D = "Set";
                setTimeout(M, 250)
            }
        })
    });
    $(".anchor .tool").mouseleave(function() {
        M()
    });
    $(".anchor .support").mouseover(function() {
        if (D != null) {
            clearTimeout(D)
        }
        $(".anchor.sub.support").show();
        $("span.support").addClass("on");
        return false
    });
    $(".anchor .support").mouseout(function() {
        $(".anchor.sub.support").mouseover(function() {
            if (D != null) {
                clearTimeout(D)
            }
            $(".anchor.sub.support").show();
            $("span.support").addClass("on");
            return false
        });
        $(".anchor.sub.support").mouseleave(function() {
            if (D != null) {
                D = null
            }
            if (D == null) {
                D = "Set";
                setTimeout(t, 250)
            }
        })
    });
    $(".anchor .support").mouseleave(function() {
        t()
    });
    $(window).bind("hashchange", function() {
        window.scrollTo(0, ($(window).scrollTop()) - 41)
    });
    if (document.location.href.indexOf("/datasheet/") == -1) {
        $(".anchor .close").click(function() {
            $(this).parent().children(".sub").hide()
        })
    }
    $(".anchor.sub span").removeAttr("sizset");
    if ($(".description .cnt").length) {
        if ($(".description .cnt").html().length < 400) {
            $(".description .showMore").hide()
        }
    }
    if ($(".features .cnt").length) {
        if ($(".features .cnt").html().length < 400) {
            $(".features .showMore").hide()
        }
    }

    // calculating parametric data table after a short delay
    // because we realized that the page does a relayout
    setTimeout(alignParametricTable, 800);

    //added to avoid sonar issues, although i didn't get any hits from the DCTEA repos
    //but there are some references in the old ticom-internal-java repo
    //adding the next to lines to avoid sonar issues, but someone should probably look more into this one
    var displayContent = window.displayContent;
    var displayGenContent = window.displayGenContent;

    $("*").removeAttr("sizset");
    $("*").removeAttr("sizcache");
    var A = $("ul.eeqlist > li.on").attr("value");
    var H = $("ul.eeqlist > li.on").attr("blockId");
    var R = "http://www.ti.com/graphics/blockdiagram/blockdiagram_images/" + H + ".gif";
    if (document.getElementById("displayeeqcontent")) {
        document.getElementById("displayeeqcontent").innerHTML = '<a href="/solution/jp/docs/redirect.tsp?appId=' + A + '"><img src="' + R + '"></img>';
        var J = "/foldercomponents/jp/docs/product/eeqlinks.tsp?appId=" + A;
        displayContent(J, "displayquicklinks");
        displayGenContent(A)
    }
    $(".eeqlink").click(function() {
        $("ul.eeqlist > li").removeClass();
        $(this).parent().addClass("on");
        var f = $(this).attr("value");
        var d = $(this).attr("blockId");
        var h = "http://www.ti.com/graphics/blockdiagram/blockdiagram_images/" + d + ".gif";
        if (document.getElementById("displayeeqcontent")) {
            document.getElementById("displayeeqcontent").innerHTML = '<a href="/solution/jp/docs/redirect.tsp?appId=' + f + '"><img src="' + h + '"></img>';
            var e = "/foldercomponents/jp/docs/product/eeqlinks.tsp?appId=" + f;
            displayContent(e, "displayquicklinks");
            displayGenContent(f)
        }
    });
    var currentRegion = "jp"
    var B = readDistCookie("DISTRIBUTOR_JP");
    if (B != "" && B != '""' && B != null && typeof B !== "undefined") {
        var h = B.split("_");
        var e = h[0];
        if (e == 10) {
             $(".dist_label").html("Digi-key の在庫");
             $(".buy_digikey").html("Digi-key から購入");
             $(".dist_button").val("Digi-key から購入")
         } else if (e == 2) {
             $(".dist_label").html("Avnet の在庫");
             $(".buy_digikey").html("Avnet から購入");
             $(".dist_button").val("Avnet から購入")
         } else if (e == 26) {
             $(".dist_label").html("Mouser の在庫");
             $(".buy_digikey").html("Mouser から購入");
             $(".dist_button").val("Mouser から購入")
         }
	    else if (e == 1 && currentRegion === "en") {
             $(".dist_label").html("");
             $(".buy_digikey").html("");
             $(".dist_button").val("")
         }
	   else if (e == 29 && currentRegion === "en") {
             $(".dist_label").html("");
             $(".buy_digikey").html("");
             $(".dist_button").val("")
         }
	   else if (e == 11) {
           $(".dist_label").html("Newark element14 Inventory");
           $(".buy_digikey").html("Buy from Newark element14");
           $(".dist_button").val("Buy from Newark element14")
       }
	   else if (e == 34) {
           $(".dist_label").html("");
           $(".buy_digikey").html("Buy from element14 Asia");
           $(".dist_button").val("Buy from element14 Asia")
       }
	   else if (e == 35) {
           $(".dist_label").html("");
           $(".buy_digikey").html("Buy from e络盟 element14");
           $(".dist_button").val("Buy from e络盟 element14")
       }
     } else {
         $(".all_dist").html("販売特約店にお問い合わせください");
         $(".dist_label").html("販売特約店在庫");
         $(".buy_digikey").html("販売特約店から購入");// perk303
         $(".dist_button").val("ご注文")
     }
    $("a.contactid").each(function() {
        if (B != "" && B != '""' && B != null && typeof B !== "undefined") {
            var i = B.split("_");
            var f = i[2];
            var g = i[0];
            var j = 0;
            if (f == 'en') {
                j = -1
            } else if (f == 'cn') {
                j = -7
            } else if (f == 'jp') {
                j = -10
            }
            var $this = $(this);
            // Get the GPN from current Location :: http://www.ti.com/product/OPA333/**/*
            var h = window.location.href.split("/")[4];
            $this.html("販売特約店へ問い合わせる");
            if (g == 10) {
            	$this.attr("href", "https://www.digikey.com/product-search/"+ f +"?KeyWords=" + h);
            } else if (g == 26) {
            	$this.attr("href", "https://www.mouser.com/Search/Refine.aspx?KeyWord=" + h);
            } else if (g == 2) {
            	$this.attr("href","https://www.avnet.com/shop/SearchDisplay?searchTerm="+ h +"&storeId=715839035&catalogId=10001&langId=" + j + "&&pageNumber=1#facet=mfName_ntk_cs%3A%22Texas+Instruments%22");
            } else if (g == 29) {
            	$this.attr("href", "https://www.element14.com/community/view-product.jspa?url=" + h + "+texas+instruments&action=list&COM=TI");
            } else if (g == 1) {
            	$this.attr("href", "https://www.arrow.com/" + f + "/products/search?q=" + h + "&filters=Manufacturer_name:Texas+Instruments");
            } else if (g == 11) {
            	$this.attr("href", "https://www.newark.com/search?st=" + h + "&mf=100066");
            } else if (g == 34) {
            	$this.attr("href", "https://www.element14.com/community/view-product.jspa?url=" + h + "+texas+instruments&action=list&COM=TI");
            } else if (g == 35) {
                $this.attr("href", "https://www.element14.com/community/view-product.jspa?url=" + h + "+texas+instruments&action=list&COM=TI");
            } else {
                $(".contactid").html("販売特約店にお問い合わせください");
                $(".contactid").attr("href", "http://www.ti.com/lsds/ti/store/distributors.page")
            }
        } else {
            $(".contactid").html("販売特約店にお問い合わせください");
            $(".contactid").attr("href", "http://www.ti.com/lsds/ti/store/distributors.page")
        }
    });
    $(".view_all_options").click(function() {
        $("#en_dist_cookie_form1").submit();
        $("#cn_dist_cookie_form1").submit();
        $("#jp_dist_cookie_form1").submit();
        setTimeout(function() {
            location.reload(true)
        }, 2000)
    })
});

$( window ).resize(function() {
	alignParametricTable();
});

if (!window.com) {
    com = new Object()
}
if (!com.TI) {
    com.TI = new Object()
}
if (!com.TI.Product) {
    com.TI.Product = new Object()
}
com.TI.Product.handleQuickLinks = function(linkName, linkTitle, id, tracking) {
    if (linkName == "TIDesign") {
        $("#TIDesign").text(linkTitle)
    }
    var q = "";
    tracking = tracking ? '&lid='+tracking : '';
    if (linkName.indexOf("main") == -1) {
        q = $("#" + linkName).text()
    }
    if (linkName.indexOf("main") != -1) {
        $("#" + linkName).removeClass("na")
    } else {
        $("#" + linkName).empty();
        if (linkName == "subcompare") {
            $("#" + linkName).removeClass("na");
            $("#" + linkName).append('<a name="' + tracking + '" id="subcomparelink">' + q + "</a>");
            $("#parametric").show()
        } else {
            $("#" + linkName).removeClass("na");
            $("#" + linkName).append('<a name="' + tracking + '" href="' + id + '">' + q + "</a>")
        }
    }
    $(".checkscroll").click(function(m) {
        var h = $(this).attr("id");
        if (id == h) {
            m.preventDefault();
            var i = $(this).attr("href");
            if (i.indexOf("http") > -1) {
                var d = i.split("#");
                i = "#" + d[1]
            }
            var e = $(i).offset().top;
            $("html,body").animate({
                scrollTop: (e - 50)
            }, 100, "swing")
        }
    });
    symFootSorting();
    var t = $("#maxLength").attr("value");
    var v = "";
    var x = "";
    var c = "";
    var a = "";
    var f = 0;
    for (var o = 0; o < t; o++) {
        $("#imgTitle" + (o + 1)).hide();
        $("#image" + (o + 1)).hide();
        $("#list2" + (o + 1)).addClass("hide");
        f = o + 1
    }
    $(".backward").addClass("disabled");
    if (t <= 1) {
        $(".forward").addClass("disabled");
    }
    var y = 1;
    var w = 1;
    var n = 1;
    for (g = 1; g <= w; g++) {
        $("#list2" + g).removeClass("hide");
    }
    $(".diagram .list2 .forward").click(function() {
        if (w >= y && (w < f)) {
            $(".backward").removeClass("disabled");
            w = w + 1;
            for (o = 1; o <= n; o++) {
                $("#list2" + o).addClass("hide");
            }
            n = n + 1;
            for (o = n; o <= w; o++) {
                $("#list2" + o).removeClass("hide");
            }
            $(".diagramCount").text(w);
            if (w == t) {
                $(".forward").addClass("disabled");
            }
            else {
                $(".forward").removeClass("disabled");
            }
        }
        return false
    });
    $(".diagram .list2 .backward").click(function() {
        z = 1;
        var d = 0;
        if (n > 1 && n <= f) {
            $(".forward").removeClass("disabled");
            for (o = n; o <= w; o++) {
                $("#list2" + o).addClass("hide");
            }
            w = w - 1;
            n = n - 1;
            for (o = n; o <= w; o++) {
                $("#list2" + o).removeClass("hide");
            }
            $(".diagramCount").text(w);
            if (w == 1) {
                $(".backward").addClass("disabled");
            }
            else {
                $(".backward").removeClass("disabled");
            }
        }
        return false
    });
    descInit()
};
com.TI.Product.ajaxCall = function(b, a) {
    $.ajax({
        url: b,
        context: document.body,
        timeout: 75000,
        dataType: "html",
        cache: false,
        success: function(c) {
            com.TI.Product.sethtml(a, c)
        },
        error: function(d, e, c) {}
    });
    com.TI.Product.sethtml = function(l, e) {
        var d = e;
        while (d.match(/(<script[^>]+javascript[^>]+>\s*(<!--)?)/i)) {
            d = d.substr(d.indexOf(RegExp.$1) + RegExp.$1.length);
            if (!(endscript = d.match(/((-->)?\s*<\/script>)/))) {
                break
            }
            block = d.substr(0, d.indexOf(RegExp.$1));
            d = d.substring(block.length + RegExp.$1.length);
            var f = document.createElement("script");
            f.text = block;
            document.getElementsByTagName("head").item(0).appendChild(f)
        }
        $("#" + l).html(e)
    }
};
com.TI.Product.goToEPitchPak = function(b) {
    if (b != "") {
        var a = window.open(b, "_blank");
        a.focus()
    }
};
com.TI.Product.printArea = function(a, b) {
    var c = window.open("", "_blank");
    try {
        c.document.open("text/html")
    } catch (e) {
    }
    c.document.write("<b>" + b + "</b>");
    c.document.write('<img src="' + a + '"/>');
    c.document.close();
    c.print()
};
com.TI.Product.displayZoomedImg = function(c, d, a, e, b) {
    $(a).addClass("on");
    $(c).show();
    $(d).show()
};
/*
 * Purpose: This next set of functions contains commonly used or pure JS functions removed
 * 			from JSP files that apply to the product folder pages from the
 * 			product project.
 *
 * Version: 0.0.1
 *
 * Created: 1/28/2018
 */
function replaceSplCharsProduct(content) {
	var myRegExp = new RegExp("&#153;|&#174;|&#8482;", "gi");
	content = content.replace(myRegExp, "");
	return content;
}

function popWinProduct(theURL, winName, features) {
	var mywin = window.mywin;
	if (mywin == "undefined" || mywin == null || mywin.closed) {
		mywin = window.open(theURL, winName, features);
	}
	mywin.location.href = theURL;
	mywin.focus();

}

function goToEPitchPakProduct(reqURL) {
	if (reqURL != "") {
		var distWindow = window.open(reqURL, "_blank");
		distWindow.focus();
	}
}
function fnCloseProduct(current) {
	$(current).closest('div').hide();
}

function sethtmlForToggleFoldersProduct(div, content) {
	var search = content;
	while (search.match(/(<script[^>]+javascript[^>]+>\s*(<!--)?)/i)) {
		search = search.substr(search.indexOf(RegExp.$1) + RegExp.$1.length);
		if (!(endscript = search.match(/((-->)?\s*<\/script>)/)))
			break;
		block = search.substr(0, search.indexOf(RegExp.$1));
		search = search.substring(block.length + RegExp.$1.length);
		var oScript = document.createElement('script');
		oScript.text = block;
		document.getElementsByTagName("head").item(0).appendChild(oScript);
	}
	document.getElementById(div).innerHTML = content;

	var jQdropdown_bind = window.jQdropdown_bind;
	if ($.isFunction(jQdropdown_bind)) {
		jQdropdown_bind();
	}
}

function ajaxCallProduct(reqUrl, targetId) {
	$.ajax({
		url : reqUrl,
		context : document.body,
		timeout : 75000,
		success : function(data) {
			$('#' + targetId).html(data);
		},
		error : function(xhr, ajaxOptions, thrownError) {
		}
	});

	function sethtml(div, content) {
		var search = content;
		while (search.match(/(<script[^>]+javascript[^>]+>\s*(<!--)?)/i)) {
			search = search
					.substr(search.indexOf(RegExp.$1) + RegExp.$1.length);
			if (!(endscript = search.match(/((-->)?\s*<\/script>)/)))
				break;
			block = search.substr(0, search.indexOf(RegExp.$1));
			search = search.substring(block.length + RegExp.$1.length);
			var oScript = document.createElement('script');
			oScript.text = block;
			document.getElementsByTagName("head").item(0).appendChild(oScript);
		}
		document.getElementById(div).innerHTML = content;
	}
}

/*
 * Purpose: This next set of functions contains commonly used or pure JS functions removed
 * 			from JSP files that apply to the product folder pages within
 * 			the CommonComponent project.
 *
 * Version: 0.0.1
 *
 * Created: 1/28/2018
 */
function enableBreadcrumbProductCC(gpnPrimFam) {
	var gpnPrimaryFamily = gpnPrimFam;
	var sessionStorageVal = sessionStorage.getItem('BCrumb');
	var value = document.getElementById(sessionStorageVal);
	if (value != null && sessionStorageVal != null) {
		document.getElementById(sessionStorageVal).style.display = "block";
	} else {
		document.getElementById(gpnPrimaryFamily).style.display = "block";
	}
}

function _format_title(str) {
	return str.replace(/^Blog Post\:\s/, '');
}
function _format_name(str) {
	return str;
}
function _format_firstP(str) {
	var contents;
	try {
		contents = (str) ? $('<div></div>').html(str).text().replace(
				/<[\/]{0,1}([A-Z][A-Z0-9]*)\b[^>]*>/ig, '') : "";
	} catch (e) {
		contents = (str) ? str.replace(/<[\/]{0,1}([A-Z][A-Z0-9]*)\b[^>]*>/ig,
				'') : "";
	}
	var words = contents.split(' '), output = [], i = 0, numwords = words.length, length = 0;
	if (numwords > 0) {
		while ((length < 100) && (i < numwords)) {
			output.push(words[i]);
			length += words[i].length;
			i++;
		}
		if (i < numwords)
			output.push("...");
	}
	return output.join(' ');
}
function _short_Date(str) {
	return (str && str.length > 0 && str.indexOf('T') > -1) ? str.split('T')[0]
			: str;
}
function _format_linkid(str) {
	var validStr = str.replace(/[^0-9|^a-z| ]/ig, '').replace(/[ ]/ig, ' '), words = validStr
			.split(' '), len = words.length, i = 0, output = [];
	while (i < len && i < 8) {
		output.push(words[i]);
		i++;
	}
	return output.join('_');
}

function prodTechDocsdocumentReadyProductCC(url) {
	$('#blogs')
			.RSSer(
					{
						template : '<div><p><a name="&lid=en_us_somepage_[linkid]" href="[link]">[customTitle]</a>&nbsp;<em> [pubdate] </em></p> </div> <div class="widget-panel-bottom"></div>',
						rssURL : url,
						maxItems : 4,
						addedTemplateTokens : {
							"customTitle" : {
								"dataField" : "title",
								"processFn" : _format_title
							},
							"shortDesc" : {
								"dataField" : "description",
								"processFn" : _format_firstP
							},
							"linkid" : {
								"dataField" : "title",
								"processFn" : _format_linkid
							}
						}
					});
};

function getFamilyformdetailsProductCC(lDropdownLevel, lFamilyId,
		lSelectedFamilyName) {
	if (lDropdownLevel == 1) {
		familyIdLevel1 = lFamilyId;
		familyNameLevel1 = lSelectedFamilyName;
		familyIdLevel2 = "";
		familyNameLevel2 = "";
		familyIdLevel3 = "";
		familyNameLevel3 = "";
		familyIdLevel4 = "";
		familyNameLevel4 = "";
		familyIdLevel5 = "";
		familyNameLevel5 = "";
	}
	if (lDropdownLevel == 2) {
		familyIdLevel2 = lFamilyId;
		familyNameLevel2 = lSelectedFamilyName;
		familyIdLevel3 = "";
		familyNameLevel3 = "";
		familyIdLevel4 = "";
		familyNameLevel4 = "";
		familyIdLevel5 = "";
		familyNameLevel5 = "";
	}
	if (lDropdownLevel == 3) {
		familyIdLevel3 = lFamilyId;
		familyNameLevel3 = lSelectedFamilyName;
		familyIdLevel4 = "";
		familyNameLevel4 = "";
		familyIdLevel5 = "";
		familyNameLevel5 = "";
	}
	if (lDropdownLevel == 4) {
		familyIdLevel4 = lFamilyId;
		familyNameLevel4 = lSelectedFamilyName;
		familyIdLevel5 = "";
		familyNameLevel5 = "";

	}
	if (lDropdownLevel == 5) {
		familyIdLevel5 = lFamilyId;
		familyNameLevel5 = lSelectedFamilyName;
	}
}

function postSortProductCC(currentDiv) {
	$(currentDiv)
			.closest('table')
			.closest('table.tblcart')
			.each(
					function() {
						var $table = $(this);
						$('th.sortColumn', $table)
								.each(
										function(column) {
											var rows = $(currentDiv)
													.closest('table')
													.closest('table.tblcart')
													.children('tbody')
													.children('tr')
													.filter(
															function() {
																return ($(this)
																		.attr(
																				"class")
																		.toString()
																		.indexOf(
																				"tbltab2") == -1 && $(
																		this)
																		.attr(
																				"class")
																		.toString()
																		.indexOf(
																				"tbl1") == -1);
															});
											var output = [], removed = {};
											// To Remove Arrow, Ti Store from
											// the List
											for (var index = 0; index < rows.length; index++) {
												var key = $(rows[index])
														.children('td').eq(
																column).text()
														.toUpperCase().trim();
												if (key == "ARROW") {
													removed.arrow = rows[index];
													rows.splice(index, 1);
													index--; // If Ti Store &
																// Arrow are
																// next to each
																// other
												}
												if (key == "TI STORE") {
													removed.store = rows[index];
													rows.splice(index, 1);
													index--;
												}
											}
											// Sort the Remaining Distributors
											// Alphabetically
											rows.sort(function(a, b) {
												var keyA = $(a).children('td')
														.eq(column).text()
														.toUpperCase().trim();
												var keyB = $(b).children('td')
														.eq(column).text()
														.toUpperCase().trim();
												if (keyA < keyB)
													return -1;
												if (keyA > keyB)
													return 1;
												return 0;
											});

											// Add Ti Store @ First
											if (removed.store != "") {
												output.push(removed.store);
											}
											// Add Remaininig Distributors which
											// are sorted alphabatically
											for (var i = 0; i < rows.length; i++) {
												output.push(rows[i]);
											}
											// Add Arrow @ Last
											if (removed.arrow != "") {
												output.push(removed.arrow);
											}

											$
													.each(
															output,
															function(index, row) {
																$table
																		.children(
																				'tbody')
																		.append(
																				row);
															});
										});
					});
}

function regionTabAmericas(current) {
	var tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
    tbody.children('tr.Asia').hide();
    tbody.children('tr.Europe').hide();
    tbody.children('tr.Surplus').hide();
    tbody.children('tr.Japan').hide();
    tbody.children('tr.Americas').show();
    tbody.children('tr.Worldwide').show();
    tbody.children('tr.Americas').addClass("alt");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').addClass("activetd active");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').addClass("selected_tab");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').removeClass("activetd active");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').removeClass("activetd active");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Surplus_region').removeClass("activetd active");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').removeClass("selected_tab");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').removeClass("selected_tab");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Surplus_region').removeClass("selected_tab");
    $(current).closest('table').closest('table.tblcart').closest('div').children(' p.disclaim').css("display","none");
    postSortProductCC(current);
}

function regionTabAsia(current) {
	var tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
	tbody.children('tr.Americas').hide();
	tbody.children('tr.Europe').hide();
	tbody.children('tr.Japan').hide();
	tbody.children('tr.Surplus').hide();
	tbody.children('tr.Asia').show();
	tbody.children('tr.Worldwide').show();
	tbody.children('tr.Asia').addClass("alt");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').addClass("activetd active");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').addClass("selected_tab");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').removeClass("activetd active");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').removeClass("activetd active");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Surplus_region').removeClass("activetd active");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').removeClass("selected_tab");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').removeClass("selected_tab");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Surplus_region').removeClass("selected_tab");
	$(current).closest('table').closest('table.tblcart').closest('div').children(' p.disclaim').css("display","none");
	postSortProductCC(current);
}

function regionTabEurope(current) {
	var tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
    tbody.children('tr.Asia').hide();
    tbody.children('tr.Americas').hide();
    tbody.children('tr.Japan').hide();
    tbody.children('tr.Surplus').hide();
    tbody.children('tr.Europe').show();
    tbody.children('tr.Worldwide').show();
    tbody.children('tr.Europe').addClass("alt");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').addClass("activetd active");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').addClass("selected_tab");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').removeClass("activetd active");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').removeClass("activetd active");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Surplus_region').removeClass("activetd active");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').removeClass("selected_tab");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').removeClass("selected_tab");
    tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Surplus_region').removeClass("selected_tab");
    $(current).closest('table').closest('table.tblcart').closest('div').children(' p.disclaim').css("display","none");
    postSortProductCC(current);
}

function regionTabJapan(current) {
	var tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
	tbody.children('tr.Asia').hide();
	tbody.children('tr.Americas').hide();
	tbody.children('tr.Japan').show();
	tbody.children('tr.Surplus').hide();
	tbody.children('tr.Europe').hide();
	tbody.children('tr.Worldwide').show();
	tbody.children('tr.Japan').addClass("alt");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Japan_region').addClass("activetd active");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Japan_region').addClass("selected_tab");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Japan_region').css("display","");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').css("display","none");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').css("display","none");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').css("display","none");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Surplus_region').css("display","none");
	$(current).closest('table').closest('table.tblcart').closest('div').children('p.disclaim').css("display","none");
	postSortProductCC(current);
}

function regionTabSurplus(current) {
	var tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
	tbody.children('tr.Asia').hide();
	tbody.children('tr.Americas').hide();
	tbody.children('tr.Japan').hide();
	tbody.children('tr.Surplus').show();
	tbody.children('tr.Europe').hide();
	tbody.children('tr.Worldwide').hide();
	tbody.children('tr.Surplus').addClass("alt");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Surplus_region').addClass("activetd active");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Surplus_region').addClass("selected_tab");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').removeClass("activetd active");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').removeClass("activetd active");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').removeClass("activetd active");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').removeClass("selected_tab");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').removeClass("selected_tab");
	tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').removeClass("selected_tab");
	$(current).closest('table').closest('table.tblcart').closest('div').children('p.disclaim').css("display","");
	postSortProductCC(current);
}


function setSiteCatalystVarsForSamplesProductCC(elementId, linkID) {

	setTimeout(function() {
		window.tiStoreCheckOut(linkID, tiPageName, tiContentGroup, elementId,
				'sample', false);
	}, 1000);
}

function closeWindowProductCC() {
	$('#mask').hide();
	$('#crosssellcart').hide();
}

function mouseMoveProductCC(ev) {
	ev = ev || window.event;
	window.mouseY = document.body.clientHeight - ev.clientY;
	return;
}

function dontHideProductCC() {
	clearTimeout(window.t);
	return;
}

function hideProductCC() {
	window.t = setTimeout(window.div.id + ".className = 'hiddenDiv'; currentImgID = ''", 100);
	return;
}

function showFloatingDivProductCC(img, ipath, size) {
	var currentImgID = window.currentImgID;
	var div = window.div;
	//sonar is saying imgX and currentImgID are not used in this file anymore
	//but since there's UI code elsewhere, I will mark these as nosonar
	var imgX = window.imgX; // NOSONAR
	var imgY = window.imgY;
	var newImg = currentImgID != img.id ? true : false;
	imgY = (currentImgID != img.id) ? img.offsetParent.offsetParent.offsetTop
			+ img.offsetParent.offsetTop : imgY;
	imgX = img.offsetParent.offsetParent.offsetLeft + img.offsetParent.offsetLeft; // NOSONAR
	currentImgID = img.id; // NOSONAR
	dontHideProductCC();

	var rollOverImg = ipath;
	var partInfo = "<div><img src = '" + rollOverImg
			+ "' /></div><br /><div class = 'rightAlign'>" + size + "</div>";
	var offsetLeft = 10;
	var offsetTop = img.height;
	var divHeight;

	div.innerHTML = partInfo;
	div.className = "floatingDiv";
	divHeight = div.clientHeight;
	div.style.left = imgX + offsetLeft;

	if (newImg)
		div.style.top = imgY + offsetTop
				- (window.mouseY > divHeight + 25 ? 0 : divHeight + 30);
	else
		dontHideProductCC();

	return;
}

function toggleExprFlyoutProductCC(t) {
	var yesOffset = $(t).offset();
	var flyout = $("#exprFlyout");
	var windowH = $(window).height();
	var windowW = $(window).width();
	var marginX = 35;
	var marginY = 15;
	var flyoutX = yesOffset.left + marginX, flyoutY = yesOffset.top + marginY;
	if (windowH - (yesOffset.top + marginY) < flyout.height()) {
		flyoutY = yesOffset.top - (flyout.height() + 2 * marginY);
		if (flyoutY < 15) {
			flyoutY = 15
		}
	}
	if (windowW - (yesOffset.left + marginX) < flyout.width()) {
		flyoutX = yesOffset.left - (flyout.width() + 2 * marginX);
		if (flyoutX < 15) {
			flyoutX = 15
		}
	}
	flyout.fadeToggle();
	flyout.offset({
		top : flyoutY,
		left : flyoutX
	});
}
function hideExprFlyoutProductCC() {
	$("#exprFlyout").fadeOut();
}

function showHide1ProductCC(show, hide) {
	var opt1 = document.getElementById(show);
	var opt2 = document.getElementById(hide);
	opt1.style.display = 'block';
	opt2.style.display = 'none';

}
function showProductCC(show) {
	var opt1 = document.getElementById(show);
	opt1.style.display = 'block';

}

function trackValuesProductCC(kWord) {
	var ev1 = new window._hbEvent("search");
	ev1.keywords = kWord;
	ev1.results = "1";
	ev1.attr1 = "SwitcherPro Search";
	ev1.attr2 = "Success";
}

function toggleSubmitButtonProductCC(status) {
	var submitButton = document.forms[window.formName].elements['designNow'];
	var submitButton1 = document.forms[window.formName].elements['designNow1'];
	if (submitButton || submitButton1) {

		if (status == true) {
			submitButton.className = "btn1";
			submitButton1.className = "btn1";
		} else {
			submitButton.className = "btndisabled";
			submitButton1.className = "btndisabled";
		}
	}
}

function canSubmitProductCC() {
	var submitForm = true;
	var validHash = window.validHash;

	if ((validHash.getItem('VinMin') == 'false')
			|| (validHash.getItem('VinMax') == 'false')
			|| (validHash.getItem('Vout') == 'false')
			|| (validHash.getItem('IoutMax') == 'false')
			|| (validHash.getItem('Vin') == 'false')) {
		submitForm = false;
	}
	toggleSubmitButtonProductCC(submitForm);
	return submitForm;
}

function setSiteCatalystVarsForBuyProductCC(elementId){
    var i = 0;
	var j = 0;
	var partnums = ';' + elementId;
	if(document.getElementById('addParts') != null){
		var addCount = document.getElementById('addParts').value;
		for(i=1; i<=addCount; i++){
			if(document.getElementById('add_'+i).checked == true){
				j=j+1;
				partnums = partnums + ';' + document.getElementById('part_'+i).innerHTML;
			}
		}
	}
}

function showPrototypeProductCC(testVar){
	$("#hasprototype").show();
	$('.hasprototypeval').show();
	$("#experimentalprototype").each(function () {
		if($(this).val() == testVar){
			$("#hasprototype").show();
			$('.hasprototypeval').show();
		}
	});
}

function checkBlogAndQuickLink(blogUrl,elementType,labelProd,comContents,comTermsLink,comTermsOfUse){
    $.ajax({
        type: "GET",
        url: blogUrl,
        dataType: "xml",
        contentType: "text/plain",
        crossDomain: true,
        crossOrigin: true,
        success: function(data){
            var items = $(data).find('item');
            if(items.length > 0)
            {
                com.TI.Product.handleQuickLinks('blog', '技術記事', '#blogs');
                if (document.getElementById("suppvideoheading") != null) {
                // modified for kintana 40245 start
                document.getElementById("suppvideoheading").innerHTML = labelProd;
                // modified for kintana 40245 end
                if (document.getElementById("suppvideodisclaim") != null) {
                    document.getElementById("suppvideodisclaim").innerHTML =
                        comContents + ' <a href="' + comTermsLink + '">' + comTermsOfUse + '</a>.';
                    }
                }
            $("<h2>技術記事</h2>" ).appendTo(elementType);
            $("<div id=\"blogs\"></div>").appendTo(elementType);
            prodTechDocsdocumentReadyProductCC(blogUrl);
            }
        }
}).done(function(){});
}

/*
 * Purpose: This next set of functions contains pure JS functions
 * to update/append tiSessionID and consent cookie flag to CAD/CAE URL
 * that apply to the product folder single-page experience project.
 * Created: 3/16/2020
 */
function updateCadCaeUltralibrarianUrl(id, col) {
    var tableEl = document.querySelector("#" + id);
    if(tableEl) {
        var tiSessionIdCookie = "";
        if(readDistCookie("tiSessionID")) {
            tiSessionIdCookie = readDistCookie("tiSessionID");
        }
        var consentCookie = getConsentCookie();
        for (var i = 1; i < tableEl.rows.length; i++) {
            var anchorEl = tableEl.rows[i].cells[col].getElementsByTagName("a")[0];
			anchorEl.setAttribute("href", anchorEl.getAttribute("href") + "&sid=" + tiSessionIdCookie + "&c=" + consentCookie);
        }
    }
}

function getConsentCookie() {
    var consentFlag = 0;
    var consentCookie = decodeURIComponent(readDistCookie("CONSENTMGR"));

    if(!consentCookie) {
        return consentFlag;
    }

    if(consentCookie.indexOf("c1:") > -1) {
        var splitCookies = consentCookie.split("|");
        for(var i = 0; i < splitCookies.length; i++) {
            if(splitCookies[i].indexOf("c1:") === 0) {
                consentFlag = splitCookies[i].split(":")[1];
                break;
            }
        }
    } else {
        consentFlag = 1;
    }

    return consentFlag;
}



/* Product folder scripts (pulled from inline) */
(function() {
    /**
     * non-jquery way of checking for document ready.
     * @param {function} fn 
     */
    function ready(fn) {
        if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }
    /**
     * Handle all the quicklinks we might have for the product folder
     * 
     * NOTE: each quicklinkRule has 'appliesIf' which is used to
     * test whether we should be applying this rule or not.
     * You'll see things like document.getElementById('subtidesign') 
     * which will return null if there's no DOM node with 
     * id="subtidesign", which is interpretted as false.
     *
     * If there are actions to be taken after the quick link is
     * created, the 'doAfter' property is an optional function
     * you can use to perform those actions if 'appliesIf'.
     */
    function applyQuickLinks() {
        var quicklinkRules = [
            {
                appliesIf: document.getElementById('TIDesigns') && document.getElementById('TIDesigns').children.length > 0,
                name: 'TIDesign',
                title: 'リファレンス・デザイン',
                id: '#TIDesigns',
                track: 'ja_JP_folder_p_quick_link_tools_software_software_development_tools',
                doAfter: function() { 
                    var subtidesign = document.getElementById('subtidesign');
                    if (subtidesign) subtidesign.style.display = "none";
                }
            }, {
                appliesIf: document.getElementById('cadsymfoot'),
                name: 'symbol',
                title: 'シンボル/フットプリント',
                id: '#cadsymfoot',
                track: 'ja_JP_folder_p_quick_link_description_features_symbols_footprints'
            }, {
                appliesIf: document.getElementById('features'),
                name: 'feature',
                title: '特長',
                id: '#features',
                track: ''
            }, {
                appliesIf: document.getElementById('descriptions'),
                name: 'description',
                title: '概要/cn',
                id: '#descriptions',
                track: ''
            }, {
                appliesIf: document.getElementById('support'),
                name: 'e2e',
                title: 'TI E2E&#8482; Community',
                id: '#support',
                track: '',
                doAfter: function() {
                    if (document.getElementById("suppvideoheading")) {
                        document.getElementById("suppvideoheading").innerHTML = '';
                    }
                }
            }, {
                appliesIf: document.querySelector('#model.model') && document.querySelector('#model.model').children.length > 0,
                name: 'model',
                title: 'モデル',
                id: '#model',
                track: 'ja_JP_folder_p_quick_link_tools_software_models'
            }, {
                appliesIf: document.getElementById('qualitydata'),
                name: 'quality',
                title: '品質および環境保護に関するデータ',
                id: '#qualitydata',
                track: 'ja_JP_folder_p_quick_link_description_features_quality_environmental_data'
            }, {
                appliesIf: document.getElementById('3rdProds') && document.getElementById('3rdProds').children.length > 0,
                name: '3rdProd',
                title: 'TI デザイン・ネットワーク',
                id: '#3rdProds',
                track: 'ja_JP_folder_p_quick_link_tools_software_ti_design_network'
            }, {
                appliesIf: document.getElementById('desKits') && document.getElementById('desKits').children.length > 0,
                name: 'desKit',
                title: '設計キット＆評価モジュール',
                id: '#desKits',
                track: 'ja_JP_folder_p_quick_link_tools_software_design_kits_evaluation_modules'
            }, {
                appliesIf: document.getElementById('devtools') && document.getElementById('devtools').children.length > 0,
                name: 'devTool',
                title: '開発ツール',
                id: '#devtools',
                track: 'ja_JP_folder_p_quick_link_tools_software_development_tools'
            }, {
                appliesIf: document.getElementById('softTools') && document.getElementById('softTools').children.length > 0,
                name: 'softTool',
                title: 'ソフトウェア',
                id: '#softTools',
                track: 'ja_JP_folder_p_quick_link_tools_software_software_development_tools'
            }, {
                appliesIf: document.getElementsByTagName('ti-recommended-eeq').length === 1,
                name: 'relEnd',
                title: 'おすすめのアプリケーション',
                id: '#relEnds',
                track: ''
            }, {
                appliesIf: document.getElementsByTagName('ti-companion-products').length === 1,
                name: 'relProd',
                title: '関連製品',
                id: '#relProds',
                track: ''
            }, {
                appliesIf: document.getElementsByTagName('ti-parametric-table').length === 1,
                name: 'parametric',
                title: '機能一覧',
                id: '#parametrics',
                track: ''
            }
        ];
        quicklinkRules.forEach(function(item){
            if (item.appliesIf) {
                com.TI.Product.handleQuickLinks(
                    item.name,
                    item.title,
                    item.id,
                    item.track
                );
                if (item.hasOwnProperty('doAfter') && typeof(item.doAfter) === 'function') {
                    item.doAfter();
                }
            }
        });
    }
    /* applyQuickLinks after DOM loaded */
    ready(applyQuickLinks);
})();
function closeAlertProduct() {
	document.getElementById('alertMeModal').style.display = "none";
}
function productAlert() {
    // assume that the info we need is already on the page
    var genericPartNumber = document.querySelector('.title-heading-label').innerText.replace(/\([^\)]*\)/g,'').replace(/[\s]*/g,'');
    var description = document.querySelector('.title-heading-description').innerText;
    $.ajax({
      type: 'GET',
        contentType: "application/json; charset=utf-8",
        url: '/myti/docs/productalert.tsp?isFolder=true&actionPerformed=showAlert&folderId=1&itemNumber=' + genericPartNumber,
        dataType: 'jsonp',
        success: function (response) {
            var alertMeModal = document.getElementById('alertMeModal');
            if(response.mode!=null){
                if(response.mode == 'productalertsexist'){
                    alertMeModal.innerHTML = [
                            '<div class="modalAlert-bg"></div>',
                            '<div class="modalAlert">',
                                '<div class="modalWindow">',
                                    '<a class="close" onclick="closeAlertProduct();"></a>',
                                    '<h2>アラートを受け取る</h2>',
                                    '<p>既に のアラートが設定されています  <strong>'+response.itemNumber+': ' +response.itemName+'.</strong></p>',
                                    '<a class="button btnA lrg" onclick="closeAlertProduct();">閉じる</a><a class="button btnA lrg" href="/myti/docs/maintainalert.tsp?sectionId=710&tabId=20357">アラートの管理</a>',
                                '</div>',
                            '</div>'
                        ].join('');
                    // show the modal
                    alertMeModal.style = "display:block";
                }
                if(response.mode == 'addproductalerts'){
                    var modalHtml = [
                        '<div class="modalAlert-bg"></div>',
                        '<div class="modalAlert">',
                        '<div class="modalWindow">',
                        '<a class="close" onclick="closeAlertProduct();"></a>',
                        '<h2>アラートを受け取る</h2>',
                        '<h3>'+response.itemNumber+': ' +response.itemName+'</h3>',
                        '<p>以下に変化があると、この製品のアラートが送信されます。</p>',
                        '<ul>',
                        '<li>データシート </li>',
                        '<li>エラッタ</li>',
                        '<li>アプリケーション・ノート</li>',
                        '<li>価格/供給時期</li>',
                        '<li>ブロック図</li>',
                        '<li>モデル</li>',
                        '<li>ホワイト・ペーパー</li>',
                        '<li>ユーザー・ガイド</li>',
                        '</ul>',
                        '<hr><a class="button btnA lrg" onclick="addalert(\'',
                        ''+response.itemNumber+'',
                        '\');">アラートを追加する</a><div class="userInfo">',
                        '<p>メール送信先： '+response.emailId
                    ];
                    if(response.accessLevel!=null && response.accessLevel==0){
                        modalHtml.push(' | <a href="/myti/docs/loginpwd.tsp?sectionId=710&tabId=20365">編集</a>');
                    }
                    modalHtml.push('<br>未 '+ response.firstName +' ? ');
                    modalHtml.push('<a href="https://ti-pass.ext.ti.com/cgi-bin/login/logout.pl?lt=myti&dpi=1&drm=1&returnto=https://www.ti.com%2Fmyti%2Fdocs%2Fhomepage.tsp%3FsectionId%3D710%26partNumber%3D'+response.itemNumber+'%26productType%3DProduct">別のユーザーとしてログインします。</a></p>');
                    modalHtml.push('</div>');
                    modalHtml.push('</div>');
                    modalHtml.push('</div>');
                    alertMeModal.innerHTML = modalHtml.join('');
                    // show the modal
                    alertMeModal.style = "display:block";
                }
            }
        },
        error: function (request, ajaxOptions, thrownError) {
            var alertMeModal = document.getElementById('alertMeModal');
            alertMeModal.innerHTML = [
                '<div class="modalAlert-bg"></div>',
                '<div class="modalAlert">',
                    '<div class="modalWindow">',
                        '<a class="close" onclick="closeAlertProduct();"></a>',
                        '<h2>アラートを受け取る</h2>',
                        '<h3>'+genericPartNumber+': '+ description+'</h3>',
                        '<p>以下に変化があると、この製品のアラートが送信されます。</p> ',
                        '<ul>',
                            '<li>データシート </li>',
                            '<li>エラッタ</li>',
                            '<li>アプリケーション・ノート</li>',
                            '<li>価格/供給時期</li>',
                            '<li>ブロック図</li>',
                            '<li>モデル</li>',
                            '<li>ホワイト・ペーパー</li>',
                            '<li>ユーザー・ガイド</li>',
                        '</ul>',
                        '<hr>',
                        '<a href="https://ti-pass.ext.ti.com/cgi-bin/login/logout.pl?lt=myti&dpi=1&drm=1&returnto=https://www.ti.com%2Fmyti%2Fdocs%2Fhomepage.tsp%3FsectionId%3D710%26partNumber%3D'+genericPartNumber+'%26productType%3DProduct" class="button btnA lrg">すぐにログインまたは登録する</a>',
                        '<div class="userInfo">',
                            '<p>アラートを受け取るには、my.TI アカウントの登録が必要です。</p>',
                        '</div>',
                    '</div>',
                '</div>'].join('');
            // show the modal
            alertMeModal.style = "display:block";
        }
    });
}
function addalert(partNumber) {
    var genericPartNumber = document.querySelector('.title-heading-label').innerText.replace(/\([^\)]*\)/g,'').replace(/[\s]*/g,'');
    var description = document.querySelector('.title-heading-description').innerText;

    $.ajax({
        url: '/myti/docs/productalert.tsp?isFolder=true&actionPerformed=addAlert&folderId=1&itemNumber='+partNumber,
        context: document.body,
        type: "GET",
        contentType: "application/json; charset=utf-8",
        dataType: "jsonp",
        success: function(response) {
            var alertMeModal = document.getElementById('alertMeModal');
            alertMeModal.innerHTML= [
                '<div class="modalAlert-bg"></div>',
                '<div class="modalAlert">',
                    '<div class="modalWindow">',
                        '<a class="close"  onclick="closeAlertProduct();"></a>',
                        '<h2>アラートの確認</h2>',
                        '<p>のアラート '+response.itemNumber+': ' +response.itemName+ ' に送信される '+response.emailId+'.</p>',
                        '<a class="button btnA lrg" onclick="closeAlertProduct();">閉じる</a><a class="button btnA lrg" href="/myti/docs/maintainalert.tsp?sectionId=710&tabId=20357">アラートの管理</a>',
                    '</div>',
                '</div>'].join('');
                // show the modal
                alertMeModal.style = "display:block";
        },
        error: function(request, textStatus, errorThrown) {
            var alertMeModal = document.getElementById('alertMeModal');
            alertMeModal.innerHTML = [
                '<div class="modalAlert-bg"></div>',
                '<div class="modalAlert">',
                    '<div class="modalWindow">',
                        '<a class="close" onclick="closeAlertProduct();"></a>',
                        '<h2>アラートを受け取る</h2>',
                        '<h3>'+genericPartNumber+': '+ description+'</h3>',
                        '<p>以下に変化があると、この製品のアラートが送信されます。</p> ',
                        '<ul>',
                            '<li>データシート </li>',
                            '<li>エラッタ</li>',
                            '<li>アプリケーション・ノート</li>',
                            '<li>価格/供給時期</li>',
                            '<li>ブロック図</li>',
                            '<li>モデル</li>',
                            '<li>ホワイト・ペーパー</li>',
                            '<li>ユーザー・ガイド</li>',
                        '</ul>',
                        '<hr>',
                        '<a href="https://ti-pass.ext.ti.com/cgi-bin/login/logout.pl?lt=myti&dpi=1&drm=1&returnto=https://www.ti.com%2Fmyti%2Fdocs%2Fhomepage.tsp%3FsectionId%3D710%26partNumber%3D'+genericPartNumber+'%26productType%3DProduct" class="button btnA lrg">すぐにログインまたは登録する</a>',
                        '<div class="userInfo">',
                            '<p>アラートを受け取るには、my.TI アカウントの登録が必要です。</p>',
                        '</div>',
                    '</div>',
                '</div>'].join('');
            // show the modal
            alertMeModal.style = "display:block";
        }
    });
}